var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41675 0.166748C8.31475 0.166748 10.6667 2.51875 10.6667 5.41675C10.6667 8.31475 8.31475 10.6667 5.41675 10.6667C2.51875 10.6667 0.166748 8.31475 0.166748 5.41675C0.166748 2.51875 2.51875 0.166748 5.41675 0.166748ZM5.41675 9.50008C7.6725 9.50008 9.50008 7.6725 9.50008 5.41675C9.50008 3.16041 7.6725 1.33341 5.41675 1.33341C3.16041 1.33341 1.33341 3.16041 1.33341 5.41675C1.33341 7.6725 3.16041 9.50008 5.41675 9.50008ZM10.3663 9.5415L12.0166 11.1912L11.1912 12.0166L9.5415 10.3663L10.3663 9.5415Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.d37a7223a9e16b9499d27a952cde7edd.svg";
export { ForwardRef as ReactComponent };